(function () {
  const MIN_VISIBLE_TAG_COUNT = 10;
  const MOBILE_LIMIT = 10;
  const SELECTED_CLASS = 'jwlz-smart-filters__native-hidden';
  const ROOT = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root || '/' : '/';
  const EMPTY_STATE_TITLE = 'No products match that filter';
  const EMPTY_STATE_COPY = 'Clear the selected filter to return to the full collection.';
  const PILOT = window.JwlzBrowsePolicy;

  const COLLECTION_RULES = [
    {
      titles: ['Hip Hop Rings'],
      handles: ['hip-hop-rings', 'hip-hop-rings-1'],
      groups: [
        group('Finish', ['Iced Out']),
        group('Ring Style', ['Statement', 'Signet', 'Band']),
        group('Theme', ['Religious', 'Animal', 'Letter', 'Symbol']),
      ],
    },
    {
      titles: ['Hip Hop Pendant'],
      handles: ['hip-hop-pendant', 'hip-hop-pendant-1'],
      groups: [
        group('Theme', ['Religious', 'Letter', 'Money', 'Animal', 'Symbol', 'Custom']),
      ],
    },
    {
      titles: ['Hip Hop Necklace'],
      handles: ['hip-hop-necklace', 'hip-hop-necklace-1'],
      groups: [
        group('Chain Style', ['Cuban', 'Tennis', 'Rope'], ['Rope']),
        group('Finish', ['Iced', 'Plain'], ['Plain']),
      ],
    },
    {
      titles: ['Cuban/Tennis Bracelet'],
      handles: ['cuban-tennis-bracelet', 'cuban-tennis-bracelet-1'],
      groups: [
        group('Chain Style', ['Cuban', 'Tennis']),
        group('Bracelet Style', ['Bangle']),
        group('Finish', ['Iced', 'Plain']),
      ],
    },
    {
      titles: ['Hip Hop Earrings'],
      handles: ['hip-hop-earrings', 'hip-hop-earrings-1'],
      groups: [
        group('Earring Style', ['Stud', 'Hoop', 'Drop']),
        group('Finish', ['Iced']),
        group('Theme', ['Statement', 'Religious']),
      ],
    },
    {
      titles: ["Moissanite Women's Rings"],
      handles: ['moissanite-womens-rings', 'moissanite-womens-rings-1'],
      groups: [
        group('Occasion', ['Engagement', 'Wedding']),
        group('Ring Style', ['Stackable', 'Statement', 'Large Carat']),
        stoneShapeGroup(),
      ],
    },
    {
      titles: ["Moissanite Men's Rings"],
      handles: ['moissanite-mens-rings', 'moissanite-mens-rings-1'],
      groups: [
        group('Finish', ['Iced Out']),
        group('Ring Style', ['Signet', 'Band', 'Statement']),
        group('Theme', ['Religious', 'Letter']),
        stoneShapeGroup(),
      ],
    },
    {
      titles: ['Moissanite Charm'],
      handles: ['moissanite-charm', 'moissanite-charm-1'],
      groups: [
        group('Theme', ['Religious', 'Letter', 'Heart', 'Animal', 'Symbol', 'Custom']),
      ],
    },
    {
      titles: ['Colored Gemstone Charms'],
      handles: ['colored-gemstone-charms', 'colored-gemstone-charms-1'],
      groups: [
        group('Theme', ['Religious', 'Letter', 'Heart', 'Animal', 'Symbol']),
      ],
    },
    {
      titles: ['Colored Gemstone Rings'],
      handles: ['colored-gemstone-rings', 'colored-gemstone-rings-1'],
      groups: [
        group('Gemstone', ['Emerald', 'Ruby', 'Sapphire', 'Opal']),
        group('Ring Style', ['Stackable', 'Statement']),
      ],
    },
    {
      titles: ['Colored Gemstone Bracelets'],
      handles: ['colored-gemstone-bracelets', 'colored-gemstone-bracelets-1'],
      groups: [
        group('Bracelet Style', ['Tennis', 'Bangle', 'Chain', 'Charm', 'Heart', 'Statement']),
      ],
    },
    {
      titles: ['Colored Gemstone Earrings'],
      handles: ['colored-gemstone-earrings', 'colored-gemstone-earrings-1'],
      groups: [
        group('Earring Style', ['Stud', 'Drop', 'Statement']),
      ],
    },
    {
      titles: ['Colored Gemstone Necklaces'],
      handles: ['colored-gemstone-necklaces', 'colored-gemstone-necklaces-1'],
      groups: [
        group('Necklace Style', ['Pendant', 'Chain', 'Layering', 'Statement']),
      ],
    },
  ];

  function group(title, labels, alwaysVisibleLabels) {
    const alwaysVisible = (alwaysVisibleLabels || []).map(normalizeTag);

    return {
      key: slugify(title),
      title: title,
      options: labels.map(function (label) {
        return {
          key: slugify(label),
          label: label,
          tags: [normalizeTag(label)],
          alwaysVisible: alwaysVisible.indexOf(normalizeTag(label)) !== -1,
        };
      }),
    };
  }

  function stoneShapeGroup() {
    const shapes = [
      ['Round', ['round']],
      ['Oval', ['oval']],
      ['Pear', ['pear']],
      ['Heart', ['heart']],
      ['Teardrop', ['teardrop']],
      ['Square', ['square']],
      ['Marquise', ['marquise']],
      ['Rectangular', ['rectangular']],
      ['Emerald Cut', ['emerald cut']],
      ['Cushion Cut', ['cushion cut']],
      ['Asscher', ['asscher']],
    ];

    return {
      key: 'stone-shape',
      title: 'Stone Shape',
      options: shapes.map(function (shape) {
        return {
          key: slugify(shape[0]),
          label: shape[0],
          tags: shape[1].map(normalizeTag),
          source: 'stoneShapes',
          alwaysVisible: false,
        };
      }),
    };
  }

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function normalizeTag(value) {
    return String(value || '').trim().toLowerCase();
  }

  function stripHtml(html) {
    return String(html || '')
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeProduct(product) {
    const rawTags = Array.isArray(product.tags)
      ? product.tags
      : String(product.tags || '')
          .split(',')
          .map(function (tag) {
            return tag.trim();
          })
          .filter(Boolean);

    const tags = rawTags.map(normalizeTag);
    const prices = getPriceRange(product);

    return {
      id: product.id,
      handle: product.handle,
      title: product.title,
      url: ROOT + 'products/' + product.handle,
      image: pickFeaturedImage(product),
      imageAlt: product.title,
      available: (product.variants || []).some(function (variant) {
        return Boolean(variant.available);
      }),
      createdAt: product.created_at ? new Date(product.created_at).getTime() : 0,
      publishedAt: product.published_at ? new Date(product.published_at).getTime() : 0,
      updatedAt: product.updated_at ? new Date(product.updated_at).getTime() : 0,
      variantCount: product.variant_count || (Array.isArray(product.variants) ? product.variants.length : 0),
      offers: product.browseIndex ? product.variants : null,
      currency: product.currency || 'USD',
      prices: prices,
      tags: tags,
      stoneShapes: [],
      searchText: ' ' + [product.title, stripHtml(product.body_html), product.product_type, product.vendor].join(' ').toLowerCase() + ' ',
    };
  }

  function pickFeaturedImage(product) {
    if (product.image && product.image.src) return product.image.src;
    if (Array.isArray(product.images) && product.images.length > 0) {
      const image = product.images[0];
      return image && image.src ? image.src : image;
    }
    const variantWithImage = (product.variants || []).find(function (variant) {
      return variant.featured_image && variant.featured_image.src;
    });
    return variantWithImage ? variantWithImage.featured_image.src : '';
  }

  function resizeImage(src, width) {
    if (!src) return '';
    return src.indexOf('?') === -1 ? src + '?width=' + width : src + '&width=' + width;
  }

  function formatMoney(amount, currency) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD',
      maximumFractionDigits: 2,
    }).format(amount);
  }

  function getPriceRange(product) {
    const variantPrices = (product.variants || [])
      .map(function (variant) {
        return Number.parseFloat(variant.price);
      })
      .filter(Number.isFinite);

    const variantCompareAt = (product.variants || [])
      .map(function (variant) {
        return Number.parseFloat(variant.compare_at_price);
      })
      .filter(Number.isFinite);

    return {
      min: variantPrices.length ? Math.min.apply(null, variantPrices) : 0,
      max: variantPrices.length ? Math.max.apply(null, variantPrices) : 0,
      compareAt: variantCompareAt.length ? Math.max.apply(null, variantCompareAt) : null,
    };
  }

  function findRule(handle, title) {
    if (PILOT && handle === PILOT.handle) {
      return { pilot: true, groups: PILOT.dimensions.map(function (dimension) { return group(dimension.title, dimension.tags, dimension.tags); }) };
    }
    const normalizedHandle = normalizeTag(handle);
    const normalizedTitle = normalizeTag(title);

    return COLLECTION_RULES.find(function (rule) {
      return (
        rule.handles.some(function (item) {
          return normalizeTag(item) === normalizedHandle;
        }) ||
        rule.titles.some(function (item) {
          return normalizeTag(item) === normalizedTitle;
        })
      );
    });
  }

  function productMatchesOption(product, option) {
    const values = option.source === 'stoneShapes' ? product.stoneShapes : product.tags;

    return option.tags.some(function (tag) {
      return values.indexOf(tag) !== -1;
    });
  }

  function buildAvailableGroups(rule, products) {
    return rule.groups
      .map(function (groupConfig) {
        const options = groupConfig.options
          .map(function (optionConfig) {
            const count = products.reduce(function (sum, product) {
              return sum + (productMatchesOption(product, optionConfig) ? 1 : 0);
            }, 0);

            return {
              key: optionConfig.key,
              label: optionConfig.label,
              tags: optionConfig.tags,
              source: optionConfig.source || 'tags',
              alwaysVisible: optionConfig.alwaysVisible,
              count: count,
              groupKey: groupConfig.key,
              groupTitle: groupConfig.title,
            };
          })
          .filter(function (option) {
            return option.alwaysVisible || option.count > (option.source === 'stoneShapes' ? 0 : MIN_VISIBLE_TAG_COUNT);
          })
          .sort(function (a, b) {
            return b.count - a.count || a.label.localeCompare(b.label);
          });

        return {
          key: groupConfig.key,
          title: groupConfig.title,
          options: options,
        };
      })
      .filter(function (groupConfig) {
        return groupConfig.options.length > 0;
      });
  }

  function flattenOptions(groups) {
    return groups
      .reduce(function (items, groupConfig) {
        return items.concat(groupConfig.options);
      }, [])
      .sort(function (a, b) {
        return b.count - a.count || a.label.localeCompare(b.label);
      });
  }

  function readSelectedState(params, groups) {
    const validKeys = flattenOptions(groups).map(function (option) {
      return option.key;
    });

    return params.getAll('jwlz_tag').filter(function (value) {
      return validKeys.indexOf(value) !== -1;
    });
  }

  function hasSmartSelection(selected) {
    return selected.length > 0;
  }

  function parseNativeConstraints(params) {
    const availabilityValue = params.get('filter.v.availability');
    const priceMinValue = params.get('filter.v.price.gte');
    const priceMaxValue = params.get('filter.v.price.lte');

    return {
      availability: availabilityValue === '1' ? true : availabilityValue === '0' ? false : null,
      priceMin: priceMinValue ? Number.parseFloat(priceMinValue) : null,
      priceMax: priceMaxValue ? Number.parseFloat(priceMaxValue) : null,
    };
  }

  function applyNativeConstraints(products, constraints) {
    return products.reduce(function (result, product) {
      if (product.offers && PILOT) {
        const offers = PILOT.eligibleOffers(product, constraints);
        if (offers.length) {
          const cheapest = offers.reduce(function (best, offer) { return offer.price < best.price ? offer : best; });
          const prices = getPriceRange({ variants: offers });
          prices.compareAt = cheapest.compare_at_price > cheapest.price ? cheapest.compare_at_price : null;
          result.push(Object.assign({}, product, { prices: prices }));
        }
        return result;
      }
      if (constraints.availability !== null && product.available !== constraints.availability) return result;
      if (Number.isFinite(constraints.priceMin) && product.prices.min < constraints.priceMin) return result;
      if (Number.isFinite(constraints.priceMax) && product.prices.min > constraints.priceMax) return result;
      result.push(product);
      return result;
    }, []);
  }

  function applySmartFilters(products, selected, options) {
    if (!selected.length) return products;

    const activeOptions = options.filter(function (option) {
      return selected.indexOf(option.key) !== -1;
    });

    return products.filter(function (product) {
      return activeOptions.some(function (option) {
        return productMatchesOption(product, option);
      });
    });
  }

  function sortProducts(products, sortBy, preserveOrder) {
    const sorted = products.slice();

    switch (sortBy) {
      case 'price-ascending':
        sorted.sort(function (a, b) {
          return a.prices.min - b.prices.min;
        });
        break;
      case 'price-descending':
        sorted.sort(function (a, b) {
          return b.prices.min - a.prices.min;
        });
        break;
      case 'title-ascending':
        sorted.sort(function (a, b) {
          return a.title.localeCompare(b.title);
        });
        break;
      case 'title-descending':
        sorted.sort(function (a, b) {
          return b.title.localeCompare(a.title);
        });
        break;
      case 'created-ascending':
        sorted.sort(function (a, b) {
          return a.createdAt - b.createdAt;
        });
        break;
      case 'created-descending':
        if (preserveOrder) {
          sorted.sort(function (a, b) { return b.createdAt - a.createdAt; });
          break;
        }
      case 'best-selling':
      case 'manual':
      default:
        if (preserveOrder) break;
        sorted.sort(function (a, b) {
          return b.publishedAt - a.publishedAt;
        });
        break;
    }

    return sorted;
  }

  function updateUrl(selected) {
    const params = new URLSearchParams(window.location.search);
    params.delete('jwlz_tag');
    selected.forEach(function (value) {
      params.append('jwlz_tag', value);
    });

    const query = params.toString();
    const nextUrl = query ? window.location.pathname + '?' + query + window.location.hash : window.location.pathname + window.location.hash;
    window.history.replaceState({}, '', nextUrl);
  }

  function createChip(option, selectedValues, className) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = className || 'jwlz-smart-filters__chip';
    button.dataset.filterValue = option.key;
    button.setAttribute('aria-pressed', selectedValues.indexOf(option.key) !== -1 ? 'true' : 'false');
    button.setAttribute('aria-label', option.groupTitle + ': ' + option.label + ' (' + option.count + ')');
    button.innerHTML =
      '<span class="jwlz-smart-filters__chip-label">' +
      option.label +
      '</span><span class="jwlz-smart-filters__chip-count">' +
      option.count +
      '</span>';
    return button;
  }

  function renderMobileRow(instance) {
    instance.mobileRow.innerHTML = '';
    instance.options.slice(0, MOBILE_LIMIT).forEach(function (option) {
      instance.mobileRow.appendChild(createChip(option, instance.selected, 'jwlz-smart-filters__mobile-chip'));
    });
  }

  function renderGroups(instance) {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    instance.groupContainer.innerHTML = '';

    instance.groups.forEach(function (groupConfig, index) {
      const detail = document.createElement('details');
      detail.className = 'jwlz-smart-filters__group';
      detail.open = index === 0;
      detail.dataset.filterGroup = groupConfig.key;

      const summary = document.createElement('summary');
      summary.className = 'jwlz-smart-filters__group-summary';
      summary.innerHTML =
        '<span class="jwlz-smart-filters__group-title"><strong>' +
        groupConfig.title +
        '</strong><span>' +
        groupConfig.options.length +
        ' options</span></span><span class="jwlz-smart-filters__group-meta">' +
        (isMobile ? '' : 'Show') +
        '</span>';

      const chipWrap = document.createElement('div');
      chipWrap.className = 'jwlz-smart-filters__chips';

      groupConfig.options.forEach(function (option) {
        chipWrap.appendChild(createChip(option, instance.selected));
      });

      detail.appendChild(summary);
      detail.appendChild(chipWrap);
      instance.groupContainer.appendChild(detail);
    });

    const details = Array.from(instance.groupContainer.querySelectorAll('.jwlz-smart-filters__group'));
    details.forEach(function (detail) {
      detail.addEventListener('toggle', function () {
        if (!detail.open) return;
        details.forEach(function (other) {
          if (other !== detail) other.open = false;
        });
      });
    });
  }

  function buildCard(product) {
    const compareText =
      Number.isFinite(product.prices.compareAt) && product.prices.compareAt > product.prices.min
        ? '<span class="jwlz-smart-filter-card__compare">' + formatMoney(product.prices.compareAt, product.currency) + '</span>'
        : '';
    const optionText = product.variantCount > 1 ? product.variantCount + ' options' : 'Single style';

    return (
      '<li class="grid__item">' +
      '<article class="jwlz-smart-filter-card">' +
      '<a class="jwlz-smart-filter-card__media" href="' +
      product.url +
      '">' +
      '<img src="' +
      resizeImage(product.image, 720) +
      '" alt="' +
      String(product.imageAlt || '').replace(/"/g, '&quot;') +
      '" loading="lazy" width="720" height="720">' +
      '</a>' +
      '<div class="jwlz-smart-filter-card__body">' +
      '<p class="jwlz-smart-filter-card__eyebrow">' +
      optionText +
      '</p>' +
      '<h3 class="jwlz-smart-filter-card__title"><a href="' +
      product.url +
      '">' +
      product.title +
      '</a></h3>' +
      '<div class="jwlz-smart-filter-card__meta">' +
      '<span class="jwlz-smart-filter-card__price">' +
      (product.offers && product.prices.min !== product.prices.max ? 'From ' : '') + formatMoney(product.prices.min, product.currency) +
      '</span>' +
      compareText +
      '</div>' +
      '<a class="jwlz-smart-filter-card__cta" href="' +
      product.url +
      '">View product</a>' +
      '</div>' +
      '</article>' +
      '</li>'
    );
  }

  function renderResults(instance) {
    const visibleItems = instance.filteredProducts.slice(0, instance.visibleCount);
    instance.resultsGrid.innerHTML = visibleItems.map(buildCard).join('');

    const total = instance.filteredProducts.length;
    instance.resultsCount.textContent = total + ' matching product' + (total === 1 ? '' : 's');
    instance.emptyState.hidden = total !== 0;
    if (total === 0) {
      const emptyTitle = instance.emptyState.querySelector('h3');
      const emptyCopy = instance.emptyState.querySelector('p');
      if (emptyTitle) emptyTitle.textContent = EMPTY_STATE_TITLE;
      if (emptyCopy) emptyCopy.textContent = EMPTY_STATE_COPY;
    }
    instance.loadMoreButton.hidden = total <= instance.visibleCount;
    instance.resetButton.hidden = !hasSmartSelection(instance.selected);

    instance.status.textContent = hasSmartSelection(instance.selected)
      ? 'Showing ' + total + ' filtered product' + (total === 1 ? '' : 's') + '.'
      : instance.options.length + ' tag filter' + (instance.options.length === 1 ? '' : 's') + ' available.';
    instance.clearButton.hidden = !hasSmartSelection(instance.selected);
  }

  function syncSelectionUi(instance) {
    instance.section.querySelectorAll('[data-filter-value]').forEach(function (button) {
      button.setAttribute('aria-pressed', instance.selected.indexOf(button.dataset.filterValue) !== -1 ? 'true' : 'false');
    });
    if (instance.pilot) {
      instance.groups.forEach(function (groupConfig) {
        const summary = instance.groupContainer.querySelector('[data-filter-group="' + groupConfig.key + '"] .jwlz-smart-filters__group-meta');
        if (summary) summary.textContent = groupConfig.options.filter(function (option) { return instance.selected.indexOf(option.key) !== -1; }).map(function (option) { return option.label; }).join(', ');
      });
    }
  }

  function toggleNativeGrid(instance, hideNative) {
    if (!instance.nativeGrid) return;
    instance.nativeGrid.classList.toggle(SELECTED_CLASS, hideNative);
    instance.results.hidden = !hideNative;
  }

  function applyState(instance) {
    instance.filteredProducts = sortProducts(
      instance.pilot ? instance.baseProducts.filter(function (product) { return PILOT.matches(product, instance.selected, instance.options); }) : applySmartFilters(instance.baseProducts, instance.selected, instance.options),
      instance.sortBy,
      instance.pilot
    );
    syncSelectionUi(instance);
    renderResults(instance);
    toggleNativeGrid(instance, hasSmartSelection(instance.selected));
    updateUrl(instance.selected);
  }

  function toggleSelection(instance, optionKey) {
    const exists = instance.selected.indexOf(optionKey) !== -1;
    instance.selected = exists
      ? instance.selected.filter(function (value) {
          return value !== optionKey;
        })
      : instance.pilot ? instance.selected.concat(optionKey) : [optionKey];
    instance.visibleCount = instance.pageSize;
    applyState(instance);
  }

  function clearSelection(instance) {
    instance.selected = [];
    instance.visibleCount = instance.pageSize;
    applyState(instance);
  }

  function bindEvents(instance) {
    instance.section.addEventListener('click', function (event) {
      const button = event.target.closest('[data-filter-value]');
      if (!button) return;
      toggleSelection(instance, button.dataset.filterValue);
    });

    instance.clearButton.addEventListener('click', function () {
      clearSelection(instance);
    });

    instance.resetButton.addEventListener('click', function () {
      clearSelection(instance);
    });

    instance.loadMoreButton.addEventListener('click', function () {
      instance.visibleCount += instance.pageSize;
      renderResults(instance);
    });
  }

  function createInstance(section, products) {
    const rule = findRule(section.dataset.collectionHandle, section.dataset.collectionTitle);
    if (!rule) return;

    const params = new URLSearchParams(window.location.search);
    const nativeConstraints = parseNativeConstraints(params);
    const baseProducts = applyNativeConstraints(products, nativeConstraints);
    const groups = buildAvailableGroups(rule, baseProducts);
    const options = flattenOptions(groups);
    if (!options.length) return;

    const instance = {
      pilot: Boolean(rule.pilot),
      section: section,
      sortBy: section.dataset.sortBy || new URLSearchParams(window.location.search).get('sort_by') || 'manual',
      pageSize: Number.parseInt(section.dataset.productsPerPage, 10) || 24,
      visibleCount: Number.parseInt(section.dataset.productsPerPage, 10) || 24,
      nativeGrid: document.querySelector('[data-jwlz-native-grid]'),
      groupContainer: section.querySelector('[data-jwlz-filter-groups]'),
      mobileRow: section.querySelector('[data-jwlz-mobile-row]'),
      lede: section.querySelector('[data-jwlz-filter-lede]'),
      status: section.querySelector('[data-jwlz-filter-status]'),
      clearButton: section.querySelector('[data-jwlz-clear-filters]'),
      results: section.querySelector('[data-jwlz-results]'),
      resultsCount: section.querySelector('[data-jwlz-results-count]'),
      resetButton: section.querySelector('[data-jwlz-results-reset]'),
      emptyState: section.querySelector('[data-jwlz-empty]'),
      resultsGrid: section.querySelector('[data-jwlz-results-grid]'),
      loadMoreButton: section.querySelector('[data-jwlz-load-more]'),
      loading: section.querySelector('[data-jwlz-filter-loading]'),
      groups: groups,
      options: options,
      selected: readSelectedState(params, groups),
      baseProducts: baseProducts,
      filteredProducts: [],
    };

    instance.lede.textContent =
      'Choose a style to narrow ' + (section.dataset.productCount || baseProducts.length) + ' products.';
    section.hidden = false;
    renderMobileRow(instance);
    renderGroups(instance);
    bindEvents(instance);
    applyState(instance);
    section.classList.remove('jwlz-smart-filters--loading');
    section.setAttribute('aria-busy', 'false');
    if (instance.loading) instance.loading.hidden = true;
  }

  async function fetchCollectionProducts(handle, productCount, sortBy) {
    if (PILOT && handle === PILOT.handle) {
      const records = [];
      let page = 1;
      let expectedTotal;
      let currency;
      while (page <= 20) {
        const url = new URL(ROOT + 'collections/' + handle, window.location.origin);
        url.searchParams.set('view', 'browse-index');
        url.searchParams.set('page', String(page));
        if (sortBy) url.searchParams.set('sort_by', sortBy);
        const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
        const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(25000) });
        if (!response.ok) throw new Error('Collection index unavailable');
        const data = await response.json();
        PILOT.validatePage(data, handle);
        if (expectedTotal === undefined) { expectedTotal = data.total; currency = data.currency; }
        if (data.total !== expectedTotal || data.currency !== currency) throw new Error('Collection changed while loading');
        records.push.apply(records, data.products);
        if (!data.has_next_page) {
          if (records.length !== expectedTotal || new Set(records.map(function (product) { return product.id; })).size !== expectedTotal) throw new Error('Incomplete collection index');
          return records.map(function (product) { return normalizeProduct(Object.assign({}, product, { browseIndex: true, currency: currency })); });
        }
        page += 1;
      }
      throw new Error('Collection index exceeds bounded pagination');
    }
    const limit = 250;
    let allProducts = [];
    const totalProducts = Number.parseInt(productCount, 10);

    if (Number.isFinite(totalProducts) && totalProducts > 0) {
      const totalPages = Math.ceil(totalProducts / limit);

      for (let firstPage = 1; firstPage <= totalPages; firstPage += 3) {
        const pageNumbers = [];
        for (let page = firstPage; page < firstPage + 3 && page <= totalPages; page += 1) {
          pageNumbers.push(page);
        }

        const pageProducts = await Promise.all(
          pageNumbers.map(async function (page) {
            const response = await fetch(
              ROOT + 'collections/' + handle + '/products.json?limit=' + limit + '&page=' + page,
              { credentials: 'same-origin' }
            );

            if (!response.ok) {
              throw new Error('Unable to load collection products for ' + handle);
            }

            const data = await response.json();
            return Array.isArray(data.products) ? data.products : [];
          })
        );

        allProducts = allProducts.concat.apply(allProducts, pageProducts);
      }

      return allProducts.map(normalizeProduct);
    }

    let page = 1;

    while (true) {
      const response = await fetch(ROOT + 'collections/' + handle + '/products.json?limit=' + limit + '&page=' + page, {
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error('Unable to load collection products for ' + handle);
      }

      const data = await response.json();
      const products = Array.isArray(data.products) ? data.products : [];
      allProducts = allProducts.concat(products);

      if (products.length < limit) break;
      page += 1;
    }

    return allProducts.map(normalizeProduct);
  }

  function ruleUsesStoneShapes(rule) {
    return rule.groups.some(function (groupConfig) {
      return groupConfig.key === 'stone-shape';
    });
  }

  function buildFilterDataUrl(handle, page) {
    const params = new URLSearchParams();
    params.set('view', 'filter-data');
    params.set('page', String(page));

    const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewThemeId) params.set('preview_theme_id', previewThemeId);

    return ROOT + 'collections/' + handle + '?' + params.toString();
  }

  async function fetchStoneShapeMap(handle) {
    const map = {};
    let page = 1;

    while (page <= 20) {
      const response = await fetch(buildFilterDataUrl(handle, page), { credentials: 'same-origin' });

      if (!response.ok) throw new Error('Unable to load stone shape data for ' + handle);

      const data = await response.json();
      const products = Array.isArray(data.products) ? data.products : [];

      products.forEach(function (product) {
        map[product.handle] = Array.isArray(product.stone_shapes)
          ? product.stone_shapes.map(normalizeTag)
          : [];
      });

      if (!data.has_next_page) break;
      page += 1;
    }

    return map;
  }

  async function initSection(section) {
    if (!section || section.dataset.jwlzReady === 'true' || section.dataset.jwlzReady === 'loading') return;
    const rule = findRule(section.dataset.collectionHandle, section.dataset.collectionTitle);
    if (!rule) return;
    section.dataset.jwlzReady = 'loading';
    if (rule.pilot) document.documentElement.classList.add('jwlz-browse-pilot');
    section.hidden = false;
    section.classList.add('jwlz-smart-filters--loading');
    section.setAttribute('aria-busy', 'true');

    try {
      const products = await fetchCollectionProducts(section.dataset.collectionHandle, section.dataset.productCount, section.dataset.sortBy);
      if (ruleUsesStoneShapes(rule)) {
        const stoneShapeMap = await fetchStoneShapeMap(section.dataset.collectionHandle);
        products.forEach(function (product) {
          product.stoneShapes = stoneShapeMap[product.handle] || [];
        });
      }
      createInstance(section, products);
      section.dataset.jwlzReady = 'true';
    } catch (error) {
      section.dataset.jwlzReady = 'error';
      section.hidden = true;
      section.classList.remove('jwlz-smart-filters--loading');
      section.removeAttribute('aria-busy');
      if (window.console && typeof window.console.error === 'function') {
        window.console.error(error);
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-jwlz-smart-filters]').forEach(function (section) {
      initSection(section);
    });
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

